/**
 * «Кандидат ждёт вас в комнате» — общее для сервера и карточки в CRM.
 *
 * Просьба владелицы 28.09.2026: «когда кандидат зашёл в комнату, рекрутёру,
 * который проводит интервью, всплывает окно в CRM: такой-то человек на
 * такую-то позицию ждёт вас в комнате, и ссылка войти, чтобы не забыли».
 *
 * Карточка живая: её не пишут в базу, а каждый раз считают из памяти сервера,
 * где комната и так знает, кто в ней сидит (server/videoInterviewWaiting.ts).
 * Поэтому она сама исчезает, когда рекрутёр вошёл или кандидат ушёл.
 */

/** Живая карточка ожидания: одна на один период ожидания одного интервью. */
export type CandidateWaitingPopup = {
  /**
   * Период ожидания: номер интервью и миг, когда кандидат вошёл в комнату.
   * Перезагрузка страницы кандидатом период не меняет, поэтому «закрыть» и
   * «звук уже был» привязаны к этому ключу, а не к интервью целиком.
   */
  key: string;
  interviewId: number;
  candidateId: number;
  candidateName: string;
  vacancyTitle: string;
  companyName: string;
  /** Когда кандидат вошёл в комнату, ISO. */
  since: string;
  /** Куда ведёт «Войти в комнату» — та же комната рекрутёра, что в списке встреч. */
  link: string;
  /**
   * Рекрутёр прямо сейчас ведёт другую встречу: карточку показываем без звука
   * и без системного уведомления, чтобы не сбить живой разговор.
   */
  silent: boolean;
};

/** Комната рекрутёра по интервью — тот же адрес, что «Открыть комнату» в списке встреч. */
export function recruiterRoomPath(
  interviewId: number,
  candidateId: number
): string {
  return `/video-interview/${interviewId}/room?candidate=${candidateId}`;
}

export function candidateWaitingKey(
  interviewId: number,
  since: number
): string {
  return `${interviewId}:${since}`;
}

/** «Айгерим Сапарова ждёт вас в комнате». Имя не сокращаем. */
export function candidateWaitingTitle(candidateName: string): string {
  const who = candidateName.trim();
  return who ? `${who} ждёт вас в комнате` : "Кандидат ждёт вас в комнате";
}

/** «Бухгалтер · ТОО «Альфа»»: пустые части не показываем. */
export function candidateWaitingSubtitle(
  vacancyTitle: string,
  companyName: string
): string {
  return [vacancyTitle.trim(), companyName.trim()].filter(Boolean).join(" · ");
}
